import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import updateShipTo from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import translate from "@insite/client-framework/Translate";
import { AddressFieldDisplayCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import CustomerAddressForm from "@insite/content-library/Components/CustomerAddressForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import EditIcon from "@tSurya/Icons/EditIcon";
import React, {useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";




const mapStateToProps = (state: ApplicationState) => {
    const addressFieldsDataView = getAddressFieldsDataView(state);
    const cartId = state.pages.checkoutShipping.cartId;
   // const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
     const cart = getCurrentCartState(state).value;
     return {
      shipToAddressFields: getAddressFieldsDataView(state).value?.shipToAddressFields,
      shouldLoadAddressFields: !addressFieldsDataView.value && !addressFieldsDataView.isLoading,
      cart
     };
 };
 const mapDispatchToProps = {
    loadAddressFields,
    updateShipTo,
};
interface OwnProps {
    shipTo: ShipToModel;
   // onEdit: () => void;
    extendedStyles?: ShippingAddressInfoDisplayStyles;
}
export interface ShippingAddressInfoDisplayStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
    iconSyles?: IconPresentationProps;
    editText?: InjectableCss;
    addressFormModal?: ModalPresentationProps;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
export const shippingAddressInfoDisplayStyles: ShippingAddressInfoDisplayStyles = {
    container: { gap: 0,
        css: css`
            width: 100% !important;
        `,
    },
    headingGridItem: {
        width: 12,
        css: css`
            padding: 10px;
            border-bottom: 1px solid ${getColor("common.border")};
            position: relative;
        `,
    },
    heading: {
        weight: 700,
        css: css`
            // margin: 0 4rem 0 0;
            font-size: 16px;
            line-height: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                        `,
                        css`
                            max-width: 100%;
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                    ],
                    "min",
                )}
        `,
    },
    addressGridItem: {
        width: 12,
        css: css`
            padding: 10px;
        `,
    },
    editLink: {
        css: css`
            display: flex;
            margin-left: auto;
            min-width: 55px;
            > span {
                display: flex;
            }
        `,
    },
    iconSyles: {
        css: css`
            width: 20px;
            margin-right: 5px;
        `,
    },
    editText: {
        css: css``,
    },
};

const ShippingAddressInfoDisplay = ({ shipTo, extendedStyles, shipToAddressFields,updateShipTo, cart,shouldLoadAddressFields,loadAddressFields}: Props) => {
    const styles = mergeToNew(shippingAddressInfoDisplayStyles, extendedStyles);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [shipToData, setShipToData] = useState<ShipToModel | null>(null);
    const [modalIsEdited, setModalIsEdited] = useState(false); 
    if(shouldLoadAddressFields){
        loadAddressFields();  
    }

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const editClickHandler = () => {
        setModalIsOpen(true);
    };
    const formCancelHandler = (e: any) => {
        e.preventDefault();
        modalCloseHandler();
    };
   // const { billToId } = cart;
const formSubmitHandler = (_: React.FormEvent<HTMLFormElement>, address: ShipToModel) => {
        if (!shipTo) {
            return;
        }
        setModalIsEdited(true);
        setShipToData(address);
        updateShipTo({
            shipTo: address,
            billToId: cart?.billToId || "",
            isEdit: true
        });
        modalCloseHandler();
    };

    return (
        <GridContainer {...styles.container} data-test-selector="shippingAddressInfoDisplay_container">
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.heading}>{translate("Shipping Address")}</Typography>
                <Link {...styles.editLink} onClick={editClickHandler} data-test-selector="checkoutReviewAndSubmit_changeShipping">
                    <Icon src={EditIcon} {...styles.iconSyles}></Icon>
                    <Typography {...styles.editText}>{translate("Edit")}</Typography>
                    <VisuallyHidden>{translate("Shipping Address")}</VisuallyHidden>
                </Link>
            </GridItem>
            <Modal
                    headline={translate("Edit Shipping Address")}
                    {...styles.addressFormModal}
                    isOpen={modalIsOpen}
                    handleClose={modalCloseHandler}
                >
                    {shipTo && modalIsOpen &&shipToAddressFields  && (
                        <CustomerAddressForm
                            address={shipTo}
                            countries={shipTo.country ? [shipTo.country] : []}
                            addressFieldDisplayCollection={shipToAddressFields}
                            onCancel={formCancelHandler}
                            onSubmit={formSubmitHandler}
                        />
                    )}
                </Modal>
            <GridItem {...styles.addressGridItem}>
                { !modalIsEdited && 
                    <AddressInfoDisplay
                    {...shipTo}
                    state={shipTo.state ? shipTo.state.abbreviation : undefined}
                    country={shipTo.country ? shipTo.country.abbreviation : undefined}
                    extendedStyles={styles.address}
                />}
               {shipToData && modalIsEdited && <AddressInfoDisplay
                    {...shipToData}
                    state={shipToData.state ? shipToData.state.abbreviation : undefined}
                    country={shipToData.country ? shipToData.country.abbreviation : undefined}
                    extendedStyles={styles.address}
                />
               }
            
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddressInfoDisplay);
